import React, { useState } from "react";
import { Form, Button, Card, Modal } from "react-bootstrap";
import { useParams, useNavigate } from "react-router-dom";
import { addHostelFacility } from "../../../services/OrganisationServices/hostelManagmentService";
import {
  callToast,
  showErrorMessages,
} from "../../../services/utilityFunctions";
import { useGlobalState } from "../../../services/hostelConst";

// Define scope options
const SCOPE_OPTIONS = [
  { value: "ROOM", label: "Room" },
  { value: "HOSTEL", label: "Hostel" },
];

const AddHostelFacilityComponent = ({ data, refresh, navigate  }) => {
  console.log("AddHostelFacilityComponent props:", { data, refresh, navigate });
  
  const { closeModal } = useGlobalState();
  const params = useParams();
  
  const hostelId = data?._HOSTEL || params.id;
  console.log("Using hostelId:", hostelId);
  
  const [isLoading, setIsLoading] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    description: "",
    scope: "ROOM",
    hostelId,
  });

  const [errors, setErrors] = useState({});

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: null }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.name?.trim()) newErrors.name = "Facility Name is required";
    if (!formData.description?.trim())
      newErrors.description = "Description is required";
    if (!formData.scope) newErrors.scope = "Scope is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    setShowConfirmation(true);
  };

  const handleConfirmedSubmit = async () => {
    setIsLoading(true);
    setShowConfirmation(false);

    try {
      const response = await addHostelFacility(formData);
      if (response.status === "success") {
        const myButton = document.getElementById("myToastButton");
        callToast(
          "success",
          "Success",
          "Facility added successfully!",
          myButton
        );
        
        if (typeof refresh === 'function') {
          await refresh();
        }
        
        closeModal();
        
      } else if (response.status === "fail") {
        showErrorMessages({ data: response, navigate: navigate || undefined });
        const myButton = document.getElementById("myToastButton");
        callToast(
          "error",
          "Error",
          response.message || "Failed to add facility",
          myButton
        );
      }
    } catch (error) {
      showErrorMessages({
        data: {
          message: "Failed to add facility",
          errors: error.message,
        },
        navigate: navigate || undefined,
      });
      const myButton = document.getElementById("myToastButton");
      callToast("error", "Error", "An unexpected error occurred", myButton);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Card className="shadow-sm">
      <Card.Body className="px-4 py-4">
        <h5 className="mb-4">Add Hostel Facility</h5>
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-4">
            <Form.Label className="fw-bold">Facility Name</Form.Label>
            <Form.Control
              type="text"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              placeholder="Enter facility name"
              isInvalid={!!errors.name}
              className="shadow-sm"
            />
            <Form.Control.Feedback type="invalid">
              {errors.name}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group className="mb-4">
            <Form.Label className="fw-bold">Description</Form.Label>
            <Form.Control
              as="textarea"
              name="description"
              value={formData.description}
              onChange={handleInputChange}
              placeholder="Enter facility description"
              rows={4}
              isInvalid={!!errors.description}
              className="shadow-sm"
            />
            <Form.Control.Feedback type="invalid">
              {errors.description}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group className="mb-4">
            <Form.Label className="fw-bold">Scope</Form.Label>
            <Form.Select
              name="scope"
              value={formData.scope}
              onChange={handleInputChange}
              isInvalid={!!errors.scope}
              className="shadow-sm"
            >
              {SCOPE_OPTIONS.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </Form.Select>
            <Form.Control.Feedback type="invalid">
              {errors.scope}
            </Form.Control.Feedback>
          </Form.Group>

          <div className="d-flex justify-content-end gap-2 mt-4">
            <Button 
              variant="light"
              onClick={closeModal}
              className="px-4"
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              type="submit"
              disabled={isLoading}
              className="px-4"
            >
              {isLoading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  Adding...
                </>
              ) : (
                "Add Facility"
              )}
            </Button>
          </div>
        </Form>
      </Card.Body>

      {/* Confirmation Modal */}
      <Modal
        show={showConfirmation}
        onHide={() => setShowConfirmation(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Facility Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="confirmation-details">
            <h6 className="mb-3">Please confirm the following details:</h6>
            <p>
              <strong>Name:</strong> {formData.name}
            </p>
            <p>
              <strong>Description:</strong> {formData.description}
            </p>
            <p>
              <strong>Scope:</strong>{" "}
              {SCOPE_OPTIONS.find((opt) => opt.value === formData.scope)?.label}
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowConfirmation(false)}
          >
            Edit
          </Button>
          <Button variant="primary" onClick={handleConfirmedSubmit}>
            Confirm & Submit
          </Button>
        </Modal.Footer>
      </Modal>
    </Card>
  );
};

export default AddHostelFacilityComponent;